import React, { useState } from 'react';
import './signup.css';
import logo from '../../assets/images/logo.png';

import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';

import { useNavigate } from 'react-router-dom';
import CryptoJS from 'crypto-js';

function Signup() {
  const navigate = useNavigate();

  const [form, setForm] = useState({
    fullName: '',
    email: '',
    password: '',
    confirmPassword: ''
  });

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const validate = () => {
    if (!form.fullName.trim()) return 'Full name is required';
    if (!form.email.trim()) return 'Email is required';

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(form.email)) return 'Invalid email format';

    if (form.password.length < 6)
      return 'Password must be at least 6 characters';

    if (form.password !== form.confirmPassword)
      return 'Passwords do not match';

    return null;
  };

  const checkEmailExists = async (email) => {
    const methods = await firebase
      .auth()
      .fetchSignInMethodsForEmail(email);
    return methods.length > 0;
  };

  const handleSignup = async (e) => {
    e.preventDefault();
    setError('');

    const validationError = validate();
    if (validationError) {
      setError(validationError);
      return;
    }

    try {
      setLoading(true);

      const exists = await checkEmailExists(form.email);
      if (exists) {
        setError('Email already exists. Please sign in.');
        return;
      }

      const userCredential = await firebase
        .auth()
        .createUserWithEmailAndPassword(form.email, form.password);

      const user = userCredential.user;

      await user.updateProfile({
        displayName: form.fullName
      });

      const userInfo = {
        uid: user.uid,
        email: user.email,
        displayName: form.fullName,
        photoURL: user.photoURL || ''
      };

      const encrypted = CryptoJS.AES.encrypt(
        JSON.stringify(userInfo),
        process.env.REACT_APP_SECERET_KEY
      ).toString();

      localStorage.setItem('userKey', encrypted);

      // ✅ FIX: reload + navigate correctly
      window.location.replace('/');

    } catch (err) {
      setError(err.message || 'Signup failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-main flex justify-content-center">
      <div className="login-main-inner signup-box">
        <img src={logo} className="App-logo" alt="logo" />

        <h3>Create your account</h3>

        <form onSubmit={handleSignup} className="signup-form">
          <input
            type="text"
            name="fullName"
            placeholder="Full Name"
            value={form.fullName}
            onChange={handleChange}
            required
          />

          <input
            type="email"
            name="email"
            placeholder="Email Address"
            value={form.email}
            onChange={handleChange}
            required
          />

          <div className="password-field">
            <input
              type={showPassword ? 'text' : 'password'}
              name="password"
              placeholder="Password"
              value={form.password}
              onChange={handleChange}
              required
            />
            <span
              className="eye-icon"
              style={{ color: '#ff03c1', cursor: 'pointer' }}
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? 'Hide' : 'Show'}
            </span>
          </div>

          <div className="password-field">
            <input
              type={showConfirmPassword ? 'text' : 'password'}
              name="confirmPassword"
              placeholder="Confirm Password"
              value={form.confirmPassword}
              onChange={handleChange}
              required
            />
            <span
              className="eye-icon"
              style={{ color: '#ff03c1', cursor: 'pointer' }}
              onClick={() =>
                setShowConfirmPassword(!showConfirmPassword)
              }
            >
              {showConfirmPassword ? 'Hide' : 'Show'}
            </span>
          </div>

          {error && <div className="error-text">{error}</div>}

          <button
            type="submit"
            disabled={loading}
            style={{ backgroundColor: '#ff03c1' }}
          >
            {loading ? 'Creating account...' : 'Sign Up'}
          </button>
        </form>

        <div className="switch-auth">
          Already have an account?{' '}
          <span
            onClick={() => navigate('/login')}
            style={{ color: '#ff03c1', cursor: 'pointer' }}
          >
            Sign in
          </span>
        </div>
      </div>
    </div>
  );
}

export default Signup;
